import React from 'react';
import { AccountPortfolioDTO } from '../../../../../Profile/Accounts/api/useAccountPortfolioQuery';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { HypotheticalReturn } from './components/HypotheticalReturn/HypotheticalReturn';
import { AssetAllocationStackChart } from './components/AssetAllocationStackChart/AssetAllocationStackChart';
import { AssetAllocationTable } from './components/AssetAllocationTable/AssetAllocationTable';
import { AssetsAllocationTableTotal } from './components/AssetsAllocationTableTotal/AssetsAllocationTableTotal';
import { InsuranceData } from '../../../useInsurance';

import { AccountType } from '../../../../../Profile/Accounts/api/useAccountsOptionsQuery';

interface ContentProps {
  accountPortfolio?: AccountPortfolioDTO;
  data: InsuranceData;
}

export const AssetAllocation = ({ accountPortfolio, data }: ContentProps) => {
  const assetAllocationSettings =
    accountPortfolio ||
    data.accountOptions.DefaultAssetAllocation.find(
      ({ AccountType: accountType }) => accountType === AccountType.Insurance,
    );

  return (
    <>
      {assetAllocationSettings && assetAllocationSettings.ShowHypotheticalReturn && (
        <Box py="16" maxWidth="50%">
          <HypotheticalReturn />
        </Box>
      )}

      <Box py="16">
        <Text fontWeight={600}>Monte Carlo Simulation Asset Allocation</Text>

        <Box pt="8">
          <AssetAllocationStackChart />
        </Box>
      </Box>

      <AssetAllocationTable />

      <AssetsAllocationTableTotal />
    </>
  );
};
